import React from 'react';
import { Check } from 'lucide-react';
import { cn } from '../utils/cn';

type RadioCardProps = {
  label: string;
  selected: boolean;
  onClick: () => void;
  className?: string;
};

export function RadioCard({ label, selected, onClick, className }: RadioCardProps) {
  return (
    <div
      onClick={onClick}
      className={cn(
        'p-4 rounded-lg border-2 cursor-pointer transition-all duration-200',
        selected ? 'border-[#236caf] bg-blue-50' : 'border-gray-200 hover:border-[#236caf] hover:bg-blue-50/50',
        className
      )}
    >
      <div className="flex items-center justify-between">
        <span className="text-lg font-medium text-gray-700">{label}</span>
        {selected && <Check className="w-5 h-5 text-[#236caf]" />}
      </div>
    </div>
  );
}